export default __webpack_public_path__ + "static/duradoc_drawing-6fba006f1d0e36b386944d7ad084c58a.jpg";